// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.propRadioGroup, .useCB {
    height: 32px;
}

.propRadioTrue {
    margin-right: 5px;
} 
`, "",{"version":3,"sources":["webpack://./src/app/workflow/modules/layout/elemProperty/elemProperty.settings.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":[".propRadioGroup, .useCB {\n    height: 32px;\n}\n\n.propRadioTrue {\n    margin-right: 5px;\n} \n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
